/**
 * Determine the display status of a Chair's Final Report to Council.
 *
 * Status logic:
 * - "Not Started" (secondary): No report has been saved yet.
 * - "In Progress" (warning): Report exists as draft with at least one field filled.
 * - "Submitted" (success): Report has been explicitly submitted to Council.
 *
 * @param {Object} params
 * @param {number|null} params.reportId - The saved report ID, or null if unsaved.
 * @param {Object} params.formData - The report form data.
 * @param {string} [params.status] - The report status: 'draft' or 'submitted'.
 * @returns {{ label: string, variant: string }} Bootstrap badge label and variant.
 */
export const chairFinalReportStatus = ({ reportId, formData, status }) => {
  if (!reportId) return { label: 'Not Started', variant: 'secondary' };

  if (status === 'submitted') return { label: 'Submitted', variant: 'success' };

  const hasContent =
    formData.gapAnalysis ||
    formData.evaluationProcess ||
    formData.integrityMatters ||
    formData.diversityIssues ||
    formData.fnsFeedback ||
    formData.generalObservations ||
    formData.candidateReports?.some((r) => r.report) ||
    formData.memberAttendance?.some((m) => m.attendance);

  if (hasContent) return { label: 'In Progress', variant: 'warning' };

  return { label: 'Not Started', variant: 'secondary' };
};
